module.exports = __webpack_public_path__ + "img/car-enclose.caf29ead.jpg";